import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {
  BaseComponent, QueryService, SearchService, TitleService, TestResult_PatientsByFacilityResultRow, FilterService, ReportKeys,
  PatientsFacilityResultComponent
} from '../../core';
import { NgxMatToastService } from 'ngx-mat-toast';
import { TranslateService } from '@ngx-translate/core';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';
import { translate } from 'src/app/core/utils/translateServiceHelper';

@Component({
  selector: 'app-report-patient-facility-result',
  templateUrl: './report-patient-facility-result.component.html',
  styleUrls: ['./report-patient-facility-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportPatientFacilityResultComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('chart', { static: true }) private patientsByFacilityResult: PatientsFacilityResultComponent;

  constructor(private queryService: QueryService,
    private searchService: SearchService,
    private titleService: TitleService,
    private filterService: FilterService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private toastr: NgxMatToastService,
    private translate: TranslateService) {
    super();
  }


  ngOnInit(): void {

    this.subscription.add(this.queryService.filtersApplied.subscribe((filtersApplied: boolean) => {
      console.debug(`Filters applied: ${filtersApplied}`);
    }));

    this.subscription.add(this.queryService.searchRequested.subscribe(() => {
      this.onSearch();
    }));

    this.onSearch();

    this.titleService.updateTitleTranslateKey('ReportMenu.PatientsByFacilityResult');
  }

  onSearch(): void {

    if (this.filterService.isReportEnabled(ReportKeys.PatientsByFacilityResult)) {
      this.googleAnalyticsService.logWithLabels('View Report', 'Report', 'View Patient By Facility/Result Report', 'filters', this.queryService.getCurrentQuery(true));
      this.subscription.add(this.searchService.getReportPatientsByFacilityResult(this.queryService.getCurrentQuery(true)).subscribe(
        (result: TestResult_PatientsByFacilityResultRow[]) => {
          if (!result || result.length === 0) {
            const title = translate(this.translate, 'ReportMenu.NoDataToShow');
            this.toastr.info(title);
            return;
          }

          this.patientsByFacilityResult.setData(result);
        }));
    } else {
      const message = translate(this.translate, 'ReportMenu.RequirePatientOrgAssay');
      const title = translate(this.translate, 'ReportMenu.ReportLoadError');
      this.toastr.error(message, title);
    }
  }

  ngOnDestroyInternal(): void {
    // Required by base component
  }

  savePDF(): void {
    this.patientsByFacilityResult.saveAsPdf();
  }

  saveImage(): void {
    this.patientsByFacilityResult.saveAsImage();
  }

}
